<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item @click="cancel"><a>新闻资讯管理</a></el-breadcrumb-item>
                <el-breadcrumb-item v-if="!$route.query.data">新增新闻资讯</el-breadcrumb-item>
                <el-breadcrumb-item v-if="$route.query.data">编辑新闻资讯</el-breadcrumb-item>

            </el-breadcrumb>
        </div>

        <el-card shadow="never" style="height: calc(100vh - 160px);overflow: auto;">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="新闻标题" prop="title">
                            <el-input v-model="form.title" placeholder="最多32个字" maxlength="32" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="新闻封面" prop="cover">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/news/upload'"
                                :show-file-list="false" :on-success="handleAvatarSuccess"
                                :headers="{token}"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="form.cover" :src="form.cover" class="avatar" style="position:absolute" />
                                <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="新闻类型" prop="newsType">
                            <el-select style="width: 100%;" v-model="form.newsType" placeholder="请选择新闻类型">
                                <el-option v-for="item in natureList" :key="item.dictKey" :label="item.dictValue"
                                    :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="内容" prop="content">
                            <!-- <el-input type="textarea" v-model="form.content" /> -->

                            <TEditor :height="'40vh'" ref="editor" :content="form.content" v-model="form.content" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <!-- <div style="width: 390px;height:844px" v-html="form.content">

        </div> -->
        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:226px;'">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { newsCreate,newsUpdate } from "@/api/admin/news"
import TEditor from '@/components/TEditor.vue';
import { queryDict } from "@/api/admin/public";
import { serviceUrl } from "@/utils/global"

export default {
    name: "demoAdd",
    components: {
        TEditor
    },
    data() {
        return {
            serviceUrl,
            token:this.$storage.get("token"),
            // 遮罩层
            loading: true,
            // 非单个禁用
            single: true,
            // 表单参数
            form: {
                content: '',
                appContent:'',
                newsType:'',
                cover: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/news.png',
                title: '',
            },
            natureList:[],
            // 表单校验
            rules: {
                title: [
                    { required: true, message: "请输入新闻封面", trigger: "blur" },
                ],
                newsType:[
                    { required: true, message: "请选择新闻类型", trigger: "change" },
                ],
                cover: [
                    { required: true, validator: this.checkCoverValidator }
                ],
                content: [
                    { required: true, validator: this.checkContentValidator },
                ],
            },
        };
    },
    created() {
        this.getQueryDict();
    },
    mounted() {
        if (this.$route.query.data) {
            this.form = JSON.parse(this.$route.query.data)
            console.log(this.form)
        } else {
        }
    },
    computed: {
    },
    methods: {
        getQueryDict() {
            queryDict({ code: 'group_news_type' }).then(res => {
                this.natureList = res.data.data;
            })
        },
        checkCoverValidator(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.form.cover != '') {
                callback()
            } else {
                callback(new Error('请上传新闻封面'))
            }
        },
        checkContentValidator(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.form.content != '') {
                callback()
            } else {
                callback(new Error('请填写内容'))
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            console.log(response, uploadFile);
            if(uploadFile.response.code == 1){
                this.form.cover = uploadFile.response.data;
            }else{
                this.$message.error("上传失败")
            }
            
        },
        beforeAvatarUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        /** 提交按钮 */
        submitForm() {
            console.log(this.form)
            var text = JSON.parse(JSON.stringify(this.form.content))
            text = text.replace(/<video/gi,"<video style='width:100% !important;height:30% !important;background:#333 !important;'")
            text = text.replace(/<img/gi,"<img style='width: 100% !important;height:auto !important;vertical-align: middle !important;max-height:100%;margin:0 auto !important;'")
            text = text.replace(/<p/gi,"<p style='text-indent: unset !important;'")

            console.log(text)
            this.form.appContent = text
            // this.form.content = this.form.appContent

            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.$route.query.data) {
                        newsUpdate(this.form).then(res=>{
                            if (res.data.code == 1) {
                                this.$message.success("编辑成功");
                                this.replace('/news', { isSx: 1 })
                            } else {
                                this.$message.error("操作失败")
                            }
                        })
                    } else {
                        newsCreate(this.form).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success("新增成功");
                                // this.$store.state.tagsView.visitedViews.forEach(e => {
                                //     if (e.path == '/groupSet') {
                                //         this.$store.dispatch('tagsView/delView', e).then(({
                                //             visitedViews
                                //         }) => {
                                //         })
                                //     }
                                // })
                                this.replace('/news', { isSx: 1 })
                                // this.$emit('isTg', true);
                            } else {
                                this.$message.error("操作失败")
                            }

                        });
                    }

                }
            });
        },

        // 取消按钮
        cancel() {
            this.replace('/news')
            // this.$emit('isTg', true)
        },
    }
};
</script>
<style scoped>
.avatar-uploader .avatar {
  width: 270px;
  height: 152px;
  display: block;
  object-fit: cover;
  position:absolute;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 270px;
  height: 152px;
  text-align: center;
}
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

/deep/ .el-dialog__body {
    padding: 10px 20px !important;
}

.custom /deep/ .el-checkbox {
    height: auto !important;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.custom /deep/ .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
}

.custom /deep/ .el-checkbox__label {
    padding-left: 0px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
}

.custom {
    height: calc(100vh - 500px);
    overflow-y: auto;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    position: relative;
}

.ylsb {
    height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
}

.ylqs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 7px;
    padding: 5px;
    cursor: pointer;
}

.eicon {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 5px;
    background: #dbdbdb;
}

.csbbb:hover .eicon {
    display: block;
}
</style>